import { Component, Input } from '@angular/core'

@Component({
    selector: 'app-skeleton-actions',
    templateUrl: './skeleton-actions.component.html',
    styleUrls: ['./skeleton-actions.component.scss'],
})
export class SkeletonActionsComponent {
    // default values
    @Input() count = 2
    @Input() buttonWidth = 140 // px
    @Input() buttonHeight = 36 // px
    @Input() gap = 16 // px

    get actions(): number[] {
        return Array(this.count).fill(0)
    }
}
